import omit from 'lodash/omit';
import { isNotEqual } from 'vet-bones/utils';

import { DiagramSnapshot } from 'src/containers/ProjectDiagram/types/diagram';
import { ModelData } from 'src/containers/ProjectDiagram/types/model';

const omitModelDisplayData = (modelData: ModelData) =>
  omit(
    modelData,
    'draftData',
    'flaggedForRedraw',
    'highlighted',
    'selection',
    'mappingIdx',
    'colorIdsByIri',
    'competencyQuestions', // competencyQuestions are compared separately
    'hiddenModelIds',
    'layoutAlgorithm'
  );

export const getOutdatedQuestionIds = (
  prevDiagram: DiagramSnapshot,
  diagram: DiagramSnapshot
) =>
  new Set(
    diagram.model.modelData.competencyQuestions
      .filter((question) => {
        const prevQuestion =
          prevDiagram.model.modelData.competencyQuestions.find(
            (q) => q.id === question.id
          );
        // question was changed
        return prevQuestion && prevQuestion.question !== question.question;
      })
      .map((question) => question.id)
  );

export const isEvaluationOutdatedForQuestions = (
  prevDiagram: DiagramSnapshot,
  diagram: DiagramSnapshot
) =>
  // added or removed competency questions
  prevDiagram.model.modelData.competencyQuestions.length !==
    diagram.model.modelData.competencyQuestions.length ||
  // updated comptetency question
  isNotEqual(
    prevDiagram.model.modelData.competencyQuestions.map((q) =>
      omit(q, 'evaluation')
    ),
    diagram.model.modelData.competencyQuestions.map((q) =>
      omit(q, 'evaluation')
    )
  );

export const isEvaluationOutdatedForDiagram = (
  prevDiagram: DiagramSnapshot,
  diagram: DiagramSnapshot
) =>
  // added or removed nodes (classes, resources)
  prevDiagram.model.nodeDataArray.length !==
    diagram.model.nodeDataArray.length ||
  // added or removed links (relationships, mappings)
  prevDiagram.model.linkDataArray.length !==
    diagram.model.linkDataArray.length ||
  // updated nodes metadata
  isNotEqual(
    prevDiagram.model.nodeDataArray.map((data) => omit(data, 'pos')),
    diagram.model.nodeDataArray.map((data) => omit(data, 'pos'))
  ) ||
  // updated links metadata
  isNotEqual(
    prevDiagram.model.linkDataArray.map((data) => omit(data, 'points')),
    diagram.model.linkDataArray.map((data) => omit(data, 'points'))
  ) ||
  // updated model metadata
  isNotEqual(
    omitModelDisplayData(prevDiagram.model.modelData),
    omitModelDisplayData(diagram.model.modelData)
  );
